import axios from "axios";
import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "index.php";
const ARCHIVED = 1;
const NOT_ARCHIVED = 0;

const setViolationArchiveStatus = (state, violationId, categoryId, status) => {
    if (categoryId) {
        const group = state.violationGroups.find((g) => g.id === categoryId);
        const violation = group.items.find((v) => v.id === violationId);
        violation.is_archive = status;
        const isAnyArchivedItems = group.items.some((i) => i.is_archive === 1);
        if (!isAnyArchivedItems) {
            group.hasFouls = 0;
        }
        return;
    }
    const violation = state.violations.find((s) => s.id.toString() === violationId.toString());
    violation.is_archive = status;
};

const setQueryParams = (filters, queryParams) => {
    if (filters && filters.status && filters.status !== "all") {
        queryParams.push(`status_type=${filters.status === "archived" ? "archive" : "active"}`);
    }
    if (filters && filters.positions && filters.positions.length) {
        const positions = filters.positions.map((p) => (filters.positionsExcept ? `-${p.value}` : p.value));
        queryParams.push(`post_codes=${positions.join(",")}`);
    }
    if (filters && filters.name) {
        queryParams.push(`search=${filters.name}`);
    }
};

const findAndUpdateViolationEntity = (violations, updatedViolation) => {
    const violation = violations.find((v) => v.id.toString() === updatedViolation.id.toString());

    violation.foulTypePosts = updatedViolation.post_code.map((post_code) => ({ post_code }));
    Object.keys(updatedViolation).forEach((key) => {
        violation[key] = updatedViolation[key];
    });
};

const state = () => ({
    violationGroups: [],
    violationGroupsAll: [],
    violations: [],
    positions: [],
    lastViolationGroupIdOfCreatedItem: 0,
    lastChangeWasGroupSorting: false,

    collections: {
        violations: [],
    },
});

const getters = {
    getViolationsByGroupId: (state) => (groupId) => state.violationGroups.find((g) => groupId === g.id).items,
    getViolation: (state) => (violationId) => {
        const violationWithoutGroup = state.violations.find((v) => v.id.toString() === violationId.toString());
        if (violationWithoutGroup) {
            return violationWithoutGroup;
        }

        const groupsViolations = state.violationGroups.reduce((acc, currentGroup) => {
            if (currentGroup.items && currentGroup.items.length) {
                acc = [...acc, ...currentGroup.items];
            }
            return acc;
        }, []);

        return groupsViolations.find((v) => v.id.toString() === violationId.toString());
    },
    isAnyArchivedItem: (state) => {
        const allViolations = state.violationGroups.reduce((acc, currentGroup) => {
            if (currentGroup.items && currentGroup.items.length) {
                acc = [...acc, ...currentGroup.items];
            }
            return acc;
        }, []);
        return [...state.violations, ...allViolations].some((v) => v.is_archive === 1);
    },
    isAnyItemExists: (state) => state.violations.length || state.violationGroups.length,
    getViolationsCollection: (state) => state.collections.violations,
};

const mutations = {
    setPositions(state, positions) {
        state.positions = positions;
    },
    setViolations(state, violations) {
        state.violations = violations;
    },
    setViolationsCollection(state, violations) {
        state.collections.violations = violations;
    },
    setViolationsToGroup(state, { id, items }) {
        const group = state.violationGroups.find((group) => group.id === id);
        group.items = items;
    },
    setViolationGroups(state, groups) {
        state.violationGroups = [];
        state.violationGroups = groups.map((group) => {
            const foulTypePosts = group.foulTypePosts ? group.foulTypePosts : [];
            return { ...group, items: group.items ? group.items : [], foulTypePosts };
        });
    },
    setViolationGroupsAll(state, groups) {
        state.violationGroupsAll = [];
        state.violationGroupsAll = groups.map((group) => {
            const foulTypePosts = group.foulTypePosts ? group.foulTypePosts : [];
            return { ...group, items: group.items ? group.items : [], foulTypePosts };
        });
    },
    putNewViolation(state, { model, categoryId }) {
        const newViolation = {
            ...model,
            is_archive: 0,
        };

        if (!categoryId) {
            state.violations.unshift(newViolation);
            return;
        }
        state.lastViolationGroupIdOfCreatedItem = categoryId;
        const group = state.violationGroups.find((g) => g.id === categoryId);
        if (!group.items) {
            return;
        }
        group.items.unshift(newViolation);
    },
    putNewViolationGroup(state, group) {
        state.violationGroups.unshift({ ...group, hasFouls: 0, items: [] });
        state.violationGroupsAll.unshift({ ...group, hasFouls: 0, items: [] });
    },
    updateViolation(state, violationData) {
        if (!violationData.category_id) {
            //findAndUpdateViolationEntity(state.violations, violationData);
            state.violations = state.violations.map((item) => {
                if (item.id.toString() === violationData.id.toString()) return violationData;
                return item;
            });
            return;
        }

        state.violationGroups = state.violationGroups.map((group) => {
            if (group.id.toString() === violationData.category_id.toString()) {
                const items = group.items.map((item) => {
                    if (item.id.toString() === violationData.id.toString()) return violationData;
                    return item;
                });
                return {
                    ...group,
                    items,
                };
            }

            return group;
        });
    },
    updateViolationGroup(state, updatedGroup) {
        const group = state.violationGroups.find((g) => g.id.toString() === updatedGroup.id.toString());
        Object.keys(group).forEach((key) => {
            if (key in updatedGroup) {
                group[key] = updatedGroup[key];
            }
        });
        const group2 = state.violationGroupsAll.find((g) => g.id.toString() === updatedGroup.id.toString());
        Object.keys(group2).forEach((key) => {
            if (key in updatedGroup) {
                group2[key] = updatedGroup[key];
            }
        });
    },
    deleteViolation(state, { id, categoryId }) {
        if (!categoryId) {
            state.violations = state.violations.filter((s) => s.id !== id);
            return;
        }
        const group = state.violationGroups.find((group) => group.id === categoryId);
        group.items = group.items.filter((i) => i.id !== id);
        if (!group.items.length) {
            group.hasFouls = 0;
            group.hasArchivedItems = 0;
        }
    },
    deleteViolationGroup(state, id) {
        const groupIndex = state.violationGroups.findIndex((g) => g.id === id);
        state.violationGroups.splice(groupIndex, 1);
        const groupIndex2 = state.violationGroupsAll.findIndex((g) => g.id === id);
        state.violationGroupsAll.splice(groupIndex2, 1);
    },
    moveViolationToArchive(state, { violationId, categoryId }) {
        setViolationArchiveStatus(state, violationId, categoryId, ARCHIVED);
    },
    moveViolationFromArchive(state, { violationId, categoryId }) {
        setViolationArchiveStatus(state, violationId, categoryId, NOT_ARCHIVED);
    },
    updateViolationCategory(state, { categoryId, violation }) {
        const group = state.violationGroups.find((g) => g.id === categoryId);
        if (!group) {
            state.violations.find((v) => v.id === violation.id).category_id = null;
            return;
        }
        group.items.find((v) => v.id === violation.id).category_id = categoryId;
    },
    setLastChangeWasGroupSortingValue(state, value) {
        state.lastChangeWasGroupSorting = value;
    },
};

const actions = {
    async fetchPositions({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/directory/position`, token);

        const { data } = await axios.get(url);

        const positions = [];
        Object.entries(data).forEach(([positionsCode, position]) => {
            positions.push({
                label: position.name,
                value: positionsCode,
            });
        });
        commit("setPositions", positions);
    },
    async getViolationsCollection({ rootState, commit }) {
        const { authToken: token } = rootState;
        const url = addAuthKey(`${apiUrl}/?r=api/foul/index`, token);
        const { data } = await axios.get(url);

        commit("setViolationsCollection", data);
    },
    async fetchViolations({ rootState, commit }, filters) {
        const token = rootState.authToken;

        const queryParams = ["pagination=0"];

        if (filters && filters.categories) queryParams.push(`categories=${filters.categories.length ? filters.categories.join(",") : null}`);

        setQueryParams(filters, queryParams);

        const url = addAuthKey(`${apiUrl}/?r=api/foul/index&positions=1&sort=-sort&${queryParams.join("&")}`, token);

        const { data } = await axios.get(url);

        if (filters && filters.categories) {
            const [firstCategory] = filters.categories;

            if (firstCategory && filters.categories.length === 1) {
                commit("setViolationsToGroup", { items: data, id: firstCategory });
                return;
            }
            commit("setViolations", data);
        }
    },
    async fetchViolationGroups({ rootState, commit }, filters) {
        const token = rootState.authToken;
        const queryParams = [];

        if (filters) {
            setQueryParams(filters, queryParams);
        }

        const url = addAuthKey(`${apiUrl}/?r=api/foul-category/index&${queryParams.join("&")}&sort=-sort`, token);

        const { data } = await axios.get(url);
        commit("setViolationGroups", data);
    },
    async fetchViolationGroupsAll({ rootState, commit }, filters) {
        const token = rootState.authToken;
        const queryParams = [];

        if (filters) {
            setQueryParams(filters, queryParams);
        }

        const url = addAuthKey(`${apiUrl}/?r=api/foul-category/index&${queryParams.join("&")}&sort=-sort`, token);

        const { data } = await axios.get(url);
        commit("setViolationGroupsAll", data);
    },    
    async createViolation({ rootState, commit }, violationData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/foul/create`, token);

        const { files, ...params } = violationData;
        const formData = serialize(params);

        files.forEach((file) => {
            formData.append("files[]", file);
        });

        const { data } = await axios.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (data.success) {
            commit("putNewViolation", {
                model: data.model,
                categoryId: violationData.category_id,
            });
        }

        return data.success;
    },
    async createViolationGroup({ rootState, commit }, groupName) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/foul-category/create`, token);

        const { data } = await axios.post(url, { name: groupName });

        if (data.success) {
            commit("putNewViolationGroup", data.model);
        }

        return data;
    },
    async changeViolationCategory({ rootState, commit }, { categoryId, violation }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/foul/update&id=${violation.id}`, token);

        await axios.put(url, { category_id: categoryId });

        commit("updateViolationCategory", { categoryId, violation });
    },
    async changeViolationsSort({ rootState }, sortingData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/foul/update-sort`, token);

        await axios.patch(url, sortingData);
    },
    async deleteViolation({ rootState, commit }, { id, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/foul/delete&id=${id}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteViolation", { id, categoryId });
        }
    },
    async deleteViolationGroup({ rootState, commit }, id) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/foul-category/delete&id=${id}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteViolationGroup", id);
        }
    },
    async moveViolationToArchive({ rootState, commit }, { violationId, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/foul/archive&id=${violationId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveViolationToArchive", { violationId, categoryId });
        }
        return data.success;
    },
    async moveViolationFromArchive({ rootState, commit }, { violationId, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/foul/archive&id=${violationId}&is_archive=0`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveViolationFromArchive", { violationId, categoryId });
        }

        return data.success;
    },
    async updateViolation({ rootState, commit }, violationData) {
        const token = rootState.authToken;

        const { id, files, ...params } = violationData;
        const url = addAuthKey(`${apiUrl}/?r=api/foul/update&id=${id}`, token);

        const formData = serialize(params);

        files.forEach((file) => {
            formData.append("files[]", file);
        });

        const { data } = await axios.put(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (data.success) {
            commit("updateViolation", {
                ...data.model,
                post_code: violationData.post_code,
            });
        }
    },
    async updateViolationGroup({ rootState, commit }, violationGroupData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/foul-category/update&id=${violationGroupData.id}`, token);

        const { data } = await axios.put(url, violationGroupData);

        if (data.success) {
            commit("updateViolationGroup", data.model);
        }

        return data;
    },
    async updateGroupsSort({ rootState, state, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/foul-category/update-sort`, token);

        const sortingData = state.violationGroups.map((group, groupIndex) => ({
            id: group.id,
            sort: state.violationGroups.length - groupIndex,
        }));

        commit("setLastChangeWasGroupSortingValue", false);

        await axios.patch(url, sortingData);
    },
    async updateSort({ rootState, state }, categoryId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/foul/update-sort`, token);

        const sortingData = [];

        if (!categoryId) {
            state.violations.forEach((v, vIndex) => {
                sortingData.push({ id: v.id, sort: state.violations.length - vIndex });
            });
        } else {
            const group = state.violationGroups.find((g) => g.id === categoryId);
            group.items.forEach((v, vIndex) => {
                sortingData.push({ id: v.id, sort: group.items.length - vIndex });
            });
        }

        await axios.patch(url, sortingData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
